export const getTailoringSizeList = state => {
    return state.list
}

export const getTailoringSizeDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/tailoringSize/getters.js